import { OnInit, OnDestroy } from "@angular/core";
var LoginCallbackComponent = /** @class */ (function () {
    function LoginCallbackComponent(authService, router, settingsService) {
        this.authService = authService;
        this.router = router;
        this.settingsService = settingsService;
    }
    LoginCallbackComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.stream = this.authService.canActivateProtectedRoutes$.subscribe(function (yes) {
            if (yes)
                return _this.router.navigate(['/home']);
            else
                return _this.router.navigate(['/login']);
        });
    };
    LoginCallbackComponent.prototype.ngOnDestroy = function () {
        this.stream.unsubscribe();
    };
    return LoginCallbackComponent;
}());
export { LoginCallbackComponent };
